import { useError } from '../hooks/ErrorContext';

export function ErrorToast() {
  const { errors, removeError } = useError();

  if (errors.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {errors.map(error => (
        <div
          key={error.id}
          data-testid={`toast-${error.type}`}
          className={`p-4 rounded-md shadow-lg max-w-sm ${
            error.type === 'error' ? 'bg-red-100 border border-red-300' :
            error.type === 'warning' ? 'bg-yellow-100 border border-yellow-300' :
            'bg-blue-100 border border-blue-300'
          }`}
        >
          <div className="flex justify-between items-start">
            <p className="text-sm">{error.message}</p>
            <button
              onClick={() => removeError(error.id)}
              className="ml-2 text-gray-400 hover:text-gray-600"
            >
              ×
            </button>
          </div>
          {error.action && (
            <button
              onClick={error.action}
              className="mt-2 text-sm underline"
            >
              {error.actionLabel || 'Try Again'}
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
